import { Injectable } from '@angular/core';
import { Archivo } from '../../../model/class/Archivo';
import { Categoria } from '../../../model/class/Categoria';
import { CategoriaProducto } from '../../../model/class/CategoriaProducto';
import {isNullOrUndefined} from 'util';


@Injectable()
export class PreviewFantasyCategoryService {

  categoria: Categoria;

  bannersSeleccionados: Archivo[] = [];
  bannersBorrados: Archivo[] = [];

  imgGaleriaSeleccioandas: Archivo[] = [];
  imgGaleriaBorradas: Archivo[] = [];

  elementos: any[] = [];

  prodBorrados: CategoriaProducto[] = [];
  catalogosBorrados: Archivo[] = [];
  imgHorizontalesBorradas: Archivo[] = [];
  imgVerticalesBorradas: Archivo[] = [];

  constructor() { }

  borrar() {
    this.elementos = undefined;
    this.categoria = undefined;
    this.prodBorrados = undefined;
    this.bannersSeleccionados = undefined;
    this.bannersBorrados = undefined;
    this.catalogosBorrados = undefined;
    this.imgGaleriaSeleccioandas = undefined;
    this.imgGaleriaBorradas = undefined;
    this.imgHorizontalesBorradas = undefined;
    this.imgVerticalesBorradas = undefined;
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/preview-fantasy-category/preview-fantasy-category.service.ts